import * as v from '@badrap/valita'
import { getRefreshToken, savedTokens } from 'src/auth'
import { Region, getBackendByRegion } from 'src/regions'

const errorSchema = v.object({
  result: v.literal('NOK'),
  reason: v.string(),
})

let refreshTokenPromise: Promise<any> = Promise.resolve(null)

export async function api<T>(
  params: {
    url: string
    withAuth: boolean
    schema: v.Type<T>
    region?: Region
  } & (
    | { method: 'GET'; body?: never }
    | { method: 'POST'; body: object | null }
  ),
) {
  let extraHeaders: HeadersInit = {}

  if (params.withAuth) {
    await refreshTokenPromise

    let tokens = savedTokens.get()

    if (!tokens) {
      return Promise.reject('you are not logged in!')
    }

    if (tokens.expires <= Date.now()) {
      refreshTokenPromise = getRefreshToken(tokens)
      await refreshTokenPromise

      tokens = savedTokens.get()

      if (!tokens) {
        return Promise.reject('you are not logged in!')
      }
    }

    // extraHeaders.Authorization = `Bearer ${tokens.idToken}`
    extraHeaders.iamidtoken = tokens.idToken
  }

  const { href } = new URL(
    params.url,
    getBackendByRegion(params.region || savedTokens.get()?.region),
  )
  const response = await window.fetch(href, {
    headers: {
      'Content-Type': 'application/json',
      'x-mc': 'mc-prov',
      ...extraHeaders,
    },
    method: params.method,
    body: params.method !== 'GET' ? JSON.stringify(params.body) : undefined,
  })

  const parsedResponse = await response.json()

  // If cognito user is not removed it will go in this statement
  if (
    parsedResponse.user &&
    parsedResponse.user.$metadata &&
    parsedResponse.user.$metadata.httpStatusCode === 400
  ) {
    return Promise.reject(
      'Something went wrong, please reach out to us at mc.notifications@idealsystems.be.',
    )
  }

  if (response.status === 400) {
    const formattedError = errorSchema.try(parsedResponse, {
      mode: 'passthrough',
    })

    if (formattedError.ok) {
      return Promise.reject(formattedError.value.reason)
    }
  }

  if (response.status === 401) {
    console.warn('log user out because token is not valid')
    savedTokens.clear()
  }

  if (!response.ok) {
    const errorMessage = await response.text()
    return Promise.reject(new Error(errorMessage))
  }

  const formattedResponse = params.schema.try(parsedResponse, {
    mode: 'passthrough',
  })

  if (!formattedResponse.ok) {
    return Promise.reject(formattedResponse.message)
  }

  return Promise.resolve(formattedResponse.value)
}
